import { render, staticRenderFns } from "./DetailConsult.vue?vue&type=template&id=3ae8a0c0&scoped=true&"
import script from "./DetailConsult.vue?vue&type=script&lang=js&"
export * from "./DetailConsult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae8a0c0",
  null
  
)

export default component.exports